import {
  ADD_EMPLOYEE_START,
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_FAILURE,
  ADD_EMPLOYEE_RESET,
  GET_EMPLOYEE_START,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_FAILURE,
  GET_EMPLOYEE_RESET,
  DELETE_EMPLOYEE_START,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_FAILURE,
  DELETE_EMPLOYEE_RESET,
  EDIT_EMPLOYEE_START,
  EDIT_EMPLOYEE_SUCCESS,
  EDIT_EMPLOYEE_FAILURE,
  EDIT_EMPLOYEE_RESET,
  VERIFY_EMPLOYEE_START,
  VERIFY_EMPLOYEE_SUCCESS,
  VERIFY_EMPLOYEE_FAILURE,
  VERIFY_EMPLOYEE_RESET,
  GET_EMPLOYEE_PROFILE_START,
  GET_EMPLOYEE_PROFILE_SUCCESS,
  GET_EMPLOYEE_PROFILE_FAILURE,
  GET_EMPLOYEE_PROFILE_RESET,
  VIEW_EMPLOYEE_START,
  VIEW_EMPLOYEE_SUCCESS,
  VIEW_EMPLOYEE_FAILURE,
  VIEW_EMPLOYEE_RESET,
  MY_EMPLOYEE_START,
  MY_EMPLOYEE_SUCCESS,
  MY_EMPLOYEE_FAILURE,
  MY_EMPLOYEE_RESET,
  TRANSFER_EMP_ASSETS,
  TRANSFER_EMP_ASSETS_SUCCESS,
  TRANSFER_EMP_ASSETS_FAILED,
} from "./actiontype"

// add employee

export const addEmployeeStart = employee => ({
  type: ADD_EMPLOYEE_START,
  payload: employee,
})

export const addEmployeeSuccess = payload => ({
  type: ADD_EMPLOYEE_SUCCESS,
  payload,
})

export const addEmployeeFailure = error => ({
  type: ADD_EMPLOYEE_FAILURE,
  payload: error,
})
export const addEmployeeReset = () => ({
  type: ADD_EMPLOYEE_RESET,
})

// get employee
export const getEmployeesStart = () => ({
  type: GET_EMPLOYEE_START,
})

export const getEmployeesSuccess = payload => ({
  type: GET_EMPLOYEE_SUCCESS,
  payload,
})

export const getEmployeesFailure = error => ({
  type: GET_EMPLOYEE_FAILURE,
  payload: error,
})
export const getEmployeeReset = () => ({
  type: GET_EMPLOYEE_RESET,
})

// delete employee

export const deleteEmployeeStart = phone_no => ({
  type: DELETE_EMPLOYEE_START,
  payload: phone_no,
})

export const deleteEmployeeSuccess = payload => ({
  type: DELETE_EMPLOYEE_SUCCESS,
  payload,
})

export const deleteEmployeeFailure = error => ({
  type: DELETE_EMPLOYEE_FAILURE,
  payload: error,
})

export const deleteEmployeeReset = () => ({
  type: DELETE_EMPLOYEE_RESET,
})

export const editEmployeeStart = payload => {
  return {
    type: EDIT_EMPLOYEE_START,
    payload,
  }
}

export const editEmployeeSuccess = payload => {
  return {
    type: EDIT_EMPLOYEE_SUCCESS,
    payload,
  }
}

export const editEmployeeError = payload => {
  return {
    type: EDIT_EMPLOYEE_FAILURE,
    payload,
  }
}

export const editEmployeeReset = () => {
  return {
    type: EDIT_EMPLOYEE_RESET,
  }
}

// verify employee

export const verifyEmployeeStart = payload => ({
  type: VERIFY_EMPLOYEE_START,
  payload,
})

export const verifyEmployeeSuccess = payload => ({
  type: VERIFY_EMPLOYEE_SUCCESS,
  payload,
})

export const verifyEmployeeFailure = error => ({
  type: VERIFY_EMPLOYEE_FAILURE,
  payload: error,
})

export const verifyEmployeeReset = () => ({
  type: VERIFY_EMPLOYEE_RESET,
})

export const getEmpProfileStart = () => ({
  type: GET_EMPLOYEE_PROFILE_START,
})

export const getEmpProfileSuccess = payload => ({
  type: GET_EMPLOYEE_PROFILE_SUCCESS,
  payload,
})

export const getEmpProfileFailure = payload => ({
  type: GET_EMPLOYEE_PROFILE_FAILURE,
  payload,
})

export const getEmpProfileReset = () => ({
  type: GET_EMPLOYEE_PROFILE_RESET,
})

//view-Employee

export const viewEmployeesStart = payload => {
  return {
    type: VIEW_EMPLOYEE_START,
    payload,
  }
}

export const viewEmployeesSuccess = payload => ({
  type: VIEW_EMPLOYEE_SUCCESS,
  payload,
})

export const viewEmployeesFailure = error => ({
  type: VIEW_EMPLOYEE_FAILURE,
  payload: error,
})
export const viewEmployeeReset = () => ({
  type: VIEW_EMPLOYEE_RESET,
})


//MY EMPLOYEE ACTION

export const myEmployeeStart = employee => ({
  type: MY_EMPLOYEE_START,
  payload: employee,
})

export const myEmployeeSuccess = payload => ({
  type:MY_EMPLOYEE_SUCCESS,
  payload,
})

export const myEmployeeFailure = error => ({
  type: MY_EMPLOYEE_FAILURE,
  payload: error,
})
export const myEmployeeReset = () => ({
  type: MY_EMPLOYEE_RESET,
})

export const transferEmpAssets = (payload) =>({
  type: TRANSFER_EMP_ASSETS,
  payload
})

export const transferEmpAssetsSuccess = (payload) =>({
  type: TRANSFER_EMP_ASSETS_SUCCESS,
  payload
})

export const transferEmpAssetsFailed = (payload) =>({
  type: TRANSFER_EMP_ASSETS_FAILED,
  payload
})